<div class="main-container">
  <p-toast></p-toast>
  <div>
    Username: {{username}}
  </div>
  <div>
    <h3>
      Connect your account to Gmail/Calendar/SpreadSheet
    </h3>
    <p-button (onClick)="openOauth2ConsentScreen()" label="Start connection"></p-button>
  </div>
  <div>
    <p-accordion>
      <p-accordionTab header="Email Signature">
        <p-tabMenu [model]="navigationItems" [activeItem]="activeItem!"></p-tabMenu>
        <div [formGroup]="signatureForm" *ngIf="signatureForm && activeItem" class="signature-form-container">
          <h3>Email signature</h3>
          <textarea formControlName="body" class="email-signature-editor" pInputTextarea></textarea>
          <p-button label="Submit" (onClick)="updateEmailSignature()"></p-button>
        </div>
        <div *ngIf="!signatureForm && !signatureCreationForm">
          <p-button label="Add signature" (onClick)="activateNewSignatureForm()"></p-button>
        </div>
        <div *ngIf="signatureCreationForm" [formGroup]="signatureCreationForm">
          <h3>Add Email signature</h3>
          <textarea formControlName="body" class="email-signature-editor" pInputTextarea></textarea>
          <p-button label="Submit" (onClick)="postEmailSignature()" [disabled]="postingSignature"></p-button>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Main Language">
        <div class="language-select-container">
          <p-dropdown [options]="languageItems" [(ngModel)]="selectedMainLanguage"></p-dropdown>
          <p-button (onClick)="updateMainLanguage()" label="Submit"></p-button>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Test Email with OAuth2 flow">
        <div class="gmail-container">
          <p>Sending test email to yourself</p>
          <textarea placeholder="body" [(ngModel)]="selectedTestingEmailBody"></textarea>
          <p-button (onClick)="sendTestEmailForNewOauth2()" label="Submit"></p-button>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div class="under-zone">
    <div class="under-zone-item" *ngIf="selectedUser">
      <span>Default lead filter</span> <p-inputSwitch [(ngModel)]="selectedUser.hasDefaultLeadFilter" (onChange)="onDefaultLeadFilterChange()"></p-inputSwitch> 
       <span *ngIf="selectedUser.hasDefaultLeadFilter">Enabled</span><span *ngIf="!selectedUser.hasDefaultLeadFilter">Disabled</span>
    </div>
  </div>
  <div>
    <br>
    <br>
    <br>
    <br>
  </div>
</div>